module.exports = __webpack_public_path__ + "static/media/image-768.24f18e7a.jpg";